import { render, staticRenderFns } from "./ProductEquipments.vue?vue&type=template&id=514d8073&scoped=true&"
import script from "./ProductEquipments.vue?vue&type=script&lang=js&"
export * from "./ProductEquipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d8073",
  null
  
)

export default component.exports